import type { SVGProps } from 'react';

const SvgChatFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_535_24549)'>
      <path
        d='M19.95 16.86C19.86 16.61 19.89 16.34 20.01 16.11C20.64 14.88 21 13.48 21 12C21 7.03 16.97 3 12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C13.58 21 15.07 20.59 16.36 19.88C16.6 19.75 16.88 19.71 17.14 19.8L19.41 20.6C20.27 20.9 21.09 20.08 20.79 19.22L19.95 16.86ZM8 13C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11C8.55 11 9 11.45 9 12C9 12.55 8.55 13 8 13ZM12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13ZM16 13C15.45 13 15 12.55 15 12C15 11.45 15.45 11 16 11C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_535_24549'>
        <rect width={18} height={18} fill='currentColor' transform='translate(3 3)' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChatFilled;
